<template>
  <div>
    <v-data-table
      v-if="files.length"
      :headers="fileHeaders"
      :items="files"
      :items-per-page="15"
      :footer-props="tableFooterProps"
      class="elevation-0"
    >
      <template v-slot:item.original_name="{ item }">
        <div class="d-flex align-center py-1">
          <v-icon
            class="mr-2"
            :color="getEntityColorByExtension(item.extension, item.original_name)"
          >
            {{ getMaterialIconByExtension(item.extension, item.original_name) }}
          </v-icon>
          <span>{{ item.original_name }}</span>
        </div>
      </template>

      <template v-slot:item.extension="{ item }">
        {{ formatFileExtension(item.extension, item.original_name) }}
      </template>

      <template v-slot:item.size="{ item }">
        {{ formatWeight(item.size) }}
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          small
          :color="btnColor"
          :loading="loadingDownload[item.id]"
          @click="downloadFile(item)"
        >
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <div
      v-else-if="showEmptyMessage"
      class="text--secondary text-center py-4"
    >
      Nessun file presente
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import {
  formatFileExtension,
  getEntityColorByExtension,
  getMaterialIconByExtension,
} from '@/utils/file-extension'

export default {
  name: 'GroupFilesTable',
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    downloadBaseUrl: {
      type: String,
      required: true,
    },
    showEmptyMessage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingDownload: {},
      fileHeaders: [
        { text: 'Nome', value: 'original_name', sortable: true },
        { text: 'Tipo', value: 'extension', sortable: true, width: '90px' },
        { text: 'Dimensione', value: 'size', sortable: true, width: '110px' },
        { text: 'Azioni', value: 'actions', sortable: false, align: 'end', width: '80px' },
      ],
      tableFooterProps: {
        itemsPerPageText: 'Righe per pagina:',
        itemsPerPageAllText: 'Tutte',
      },
    }
  },
  computed: {
    ...mapGetters(['token', 'partnerSettings']),
    btnColor() {
      return this.partnerSettings?.colors?.btn ?? 'primary'
    },
  },
  methods: {
    formatFileExtension,
    getEntityColorByExtension,
    getMaterialIconByExtension,
    downloadFile(file) {
      this.$set(this.loadingDownload, file.id, true)

      axios({
        method: 'get',
        url: `${this.downloadBaseUrl}${file.id}`,
        responseType: 'arraybuffer',
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      })
        .then(response => {
          this.forceFileDownload(response, file.original_name)
        })
        .catch(error => {
          const status = error.response?.status
          if (status === 403) {
            this.$store.dispatch('set_alert', {
              msg: 'Non hai i permessi necessari per scaricare il file.',
              type: 'error',
            })
          } else {
            this.$store.dispatch('set_alert', {
              msg: 'Errore nel download, si prega di riprovare.',
              type: 'error',
            })
          }
        })
        .finally(() => {
          this.$set(this.loadingDownload, file.id, false)
        })
    },
    forceFileDownload(response, title) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    },
    formatWeight(size) {
      if (!size) {
        return '—'
      }

      let finalSize = size / 1000

      if (finalSize > 1000) {
        finalSize /= 1000

        return `${finalSize.toFixed(2)} MB`
      }

      return `${finalSize.toFixed(0)} KB`
    },
  },
}
</script>
